import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";
import Cookies from "js-cookie";

const getUserid = Cookies.get("userid");

export const add_files = (
  subject,
  content,
  status,
  filename,
  locating,
  subjectlocating
) => {
  return api.post(`${ApiEndpointConstants.ADDMODEL}`, {
    userid: getUserid,
    subject,
    content,
    status,
    filename,
    locating,
    subjectlocating,
  });
};
